export default __webpack_public_path__ + "static/rs-empresarial_05-fdbb364a17a57394ec8e30de26da445c.png";